// use-subscription.ts — Subscription suite, query.

'use client';

import { ROUTE_CONTRACTS } from '@cabal/shared/api-client';
import type { GetCurrentSubscriptionResponse } from '@cabal/shared/domain/billing/subscription/types.js';
import { useApi } from '@/contexts/api';
import { useRouteAuthEnabled } from '@/hooks/routing';
import { useQueryHook } from '@/lib/query/use-query-hook';
import type { QueryResult } from '@/types/async-protocol';
import { subscriptionKeys } from './keys';

export type CurrentSubscription = GetCurrentSubscriptionResponse;

export function useSubscription(): QueryResult<CurrentSubscription> {
  const api = useApi();
  const enabled = useRouteAuthEnabled({ route: ROUTE_CONTRACTS.subscription.current });

  return useQueryHook<CurrentSubscription, Error>({
    queryKey: subscriptionKeys.current(),
    queryFn: () => api.subscription.current(),
    options: { enabled },
  });
}
